<template>
  <div class="ws-main-panel d-flex inherit-height ws-center-panel full-width pa-2">
    <div class="line-1-container" :class="hasTwoRows ? 'mb-2' : ''" :style="{ maxHeight: `${heightLine1}px` }">
      <!-- Closed Panels -->
      <div v-if="mx_isDispoView && !isLine1Expanded" class="closed-panels closed-panel-first">
        <v-badge v-if="activeInfoItems.length>0" x-small :content="activeInfoItems.length" color="primary" offset-y="12"><p class="mr-2">Infos</p> </v-badge>
        <p v-else class="mr-2">Infos</p>
        <v-badge v-if="infoFeedUnreadCount > 0" class="pl-2" :content="`${infoFeedUnreadCount} geänderte oder neue`" color="error" offset-y="12">
          <div style="width: 20px">&nbsp;</div>
        </v-badge>
      </div>
      <div v-if="!isLine1Expanded" class="closed-panels closed-panel-second" style="flex: 1">
        <v-badge v-if="activePikettItems.length>0" :content="activePikettItems.length"  color="primary" class="mr-1" offset-y="12">
          <p class="mr-2">Pikett</p>
        </v-badge>
        <p v-else class="mr-2">Pikett</p>

        <v-badge v-if="activePikettsUnreadCount>0"  :content="`${activePikettsUnreadCount} geänderte oder neue`" color="error" offset-y="12">
          <div style="width: 20px">&nbsp;</div>
        </v-badge>
      </div>

      <!-- Open Panels -->
      <div
        v-if="mx_isDispoView && isLine1Expanded"
        :style="{ opacity: isLine1Expanded ? 1 : 0 }"
        class="d-flex overflow-hidden pr-2"
        style="width: 600px !important"
      >
        <info-feed :badgeValue="infoFeedUnreadCount" :badgeColor="infoBadgeColor" />
      </div>
      <div v-if="(mx_isDispoView || mx_isZueri9View) && isLine1Expanded" :style="{ opacity: isLine1Expanded ? 1 : 0 }" class="d-flex" style="flex: 1">
        <pikett-table :badgeValue="activePikettsUnreadCount" :badgeColor="pikettBadgeColor" />
      </div>
    </div>

    <absences :remainingHeight="hasTwoRows ? heightLine1 : 0" class="flex-shrink-0" />
    <v-btn v-if="mx_isDispoView || mx_isZueri9View" small class="expand-btn" rounded color="white" icon @click="togglePanel">
      <v-icon>mdi-chevron-{{ isLine1Expanded ? 'up' : 'down' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import PikettTable from '@/modules/customerVbzWorksheet/viewComponents/pikett/Pikett.vue';
import Absences from '@/modules/customerVbzWorksheet/viewComponents/absences/Absences.vue';
import InfoFeed from '@/modules/customerVbzWorksheet/viewComponents/infos/InfoFeed.vue';
import commonMixin from '@/mixins/common';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import { mapGetters, mapState } from 'vuex';
import worksheetService from '@/modules/customerVbzWorksheet/worksheetService';
import dateUtils from '@/common/dateUtils';

export default {
  mixins: [commonMixin, wsMixin],
  components: { PikettTable, InfoFeed, /*AbsenceTable,*/ Absences },

  data() {
    return {
      isLine1Expanded: true,
      dividerPos: 300,
      dividerOpacity: 0.3,
      onDividerMoving: false,

      previousPiketts: [],
      lastViewedTimes: {},

      badgeColors: {
        read: 'info',
        unread: 'red',
      },
    };
  },
  computed: {
    ...mapGetters('vbzWorksheet', ['getPikettsPerDay']),
    ...mapState('vbzWorksheet', ['contextDate']),
    infoFeedUnreadCount() {
      return this.mx_activeInfoFeedsAtSelectedDate;
    },
    activePikettsUnreadCount() {
      return this.mx_activePikettsAtSelectedDate;
    },
    heightLine1() {
      return this.isLine1Expanded ? 300 : 80;
    },
    hasTwoRows() {
      return this.mx_isDispoView || this.mx_isZueri9View;
    },
    activeInfoItems() {
      let key = worksheetService.buildDateIdFromDate(this.contextDate);
      let infos = this.informationsByDate[key] || [];
      return infos ? infos.filter((i) => !i.deleted) : [];
    },
    activePikettItems() {
      let key = worksheetService.buildDateIdFromDate(this.contextDate);
      let piketts = this.pikettsByDate[key] || [];
      return piketts ? piketts.filter((i) => !i.deleted && this.$route.name.includes(i.assignedTo)) : [];
    },
    infoBadgeColor() {
      if (!this.activeInfoItems.length) return '';
      if (!this.lastViewedTimes[this.contextDateFormatted]) return this.badgeColors.unread; // Ungelesen, wenn undefined
      const hasNewInfo = this.activeInfoItems.some((info) => new Date(info.createdAt) > this.lastViewedTimes[this.contextDateFormatted]);
      return hasNewInfo ? this.badgeColors.unread : this.badgeColors.read;
    },
    pikettBadgeColor() {
      if (!this.activePikettItems.length) return '';
      if (!this.lastViewedTimes[this.contextDateFormatted]) return this.badgeColors.unread; // Ungelesen, wenn undefined
      const hasNewPikett = this.activePikettItems.some((pikett) => new Date(pikett.createdAt) > this.lastViewedTimes[this.contextDateFormatted]);
      return hasNewPikett ? this.badgeColors.unread : this.badgeColors.read;
    },
    contextDateFormatted() {
      return dateUtils.formatDateAsYYYYMMDD(this.contextDate);
    },
  },

  methods: {
    togglePanel() {
      this.isLine1Expanded = !this.isLine1Expanded;
      if (this.isLine1Expanded) {
        setTimeout(() => {
          this.activeInfoItems.forEach((i) => (i.receivedAt = 0));
          this.activePikettItems.forEach((i) => (i.receivedAt = 0));
        }, 10 * 1000);
        // let clonedLastViewedTimes = Object.assign({},this.lastViewedTimes)
        // clonedLastViewedTimes[this.contextDateFormatted] = new Date()
        // this.lastViewedTimes = clonedLastViewedTimes;
      }
    },
  },
};
</script>

<style scoped>
.line-1-container {
  display: flex;
  flex: 1;
  flex-wrap: nowrap;
  overflow: hidden;
  transition: opacity 800ms ease;
}

.ws-center-panel {
  display: flex;
  flex-direction: column;
}
.theme--light .ws-main-panel {
  background: #e0e0e0;
}
.theme--dark .ws-main-panel {
  background: #101010;
}
.expand-btn {
  z-index: 10000;
  background: grey;
  position: absolute !important;
  top: 2px;
  right: 2px;
}

.theme--light .closed-panels {
  background: #ffffff;
}
.theme--dark .closed-panels {
  background: #272727;
}

.closed-panels {
  display: flex;
  align-items: center;
  padding: 0 0.8em;
  border-radius: 8px;
  font-weight: bold;
}

.closed-panels p {
  margin-bottom: 0;
}

.closed-panel-first {
  width: 600px;
  margin-right: 0.5em;
}

.closed-panel-second {
  flex: 1;
}
</style>
